/****************************************************
 * Module Name:  SendMessageModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import { Box, Button, Container, TextField, Typography, } from "@mui/material";
import "./../../style/modalstyle.css";
import Constants from "../../utility/constants";
import logo from '../../images/pansuriya.jpg'
import { Modal } from "react-bootstrap";


const SendMessageModal = ({ show, textmessage, handleSendMessage, handleClose }) => {
    const [message, setMessage] = useState(textmessage);
    const title = "Send Message";

    const handleSend = () => {
        handleSendMessage(message);
    }

    return (
        show ? (
            <Modal show={show} onHide={handleClose} enforceFocus={false}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <img src={logo} height="40pt"
                            width="40pt"
                            alt={Constants.COMPANY_SITE} />
                        &nbsp;&nbsp;{title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container maxWidth="xxl">
                        <Box
                            sx={{
                                width: "100%",
                                position: "relative",
                                "& .MuiTablePagination-selectLabel": {
                                    marginTop: "15px",
                                },
                                "& .MuiTablePagination-displayedRows": {
                                    marginTop: "15px",
                                },
                                "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                                    fontWeight: Constants.defaultFontWeight,
                                },
                                "& .css-1knaqv7-MuiButtonBase-root-MuiButton-root": {
                                    color: "#1976d2",
                                    padding: "4px 5px",
                                    borderRadius: "4px",
                                },
                                "& .css-cc8tf1": {
                                    fontWeight: Constants.defaultFontWeight,
                                },
                                "& .css-znmrd6-MuiButtonBase-root-MuiButton-root": {
                                    color: "#1976d2",
                                    padding: "5px 5px",
                                    borderRadius: "4px",
                                },
                                height: "20vh",
                            }}
                        >
                            <TextField
                                margin="normal"
                                fullWidth
                                multiline
                                rows={4}
                                label={title}
                                placeholder={title}
                                value={message}
                                onChange={(e) => {
                                    setMessage(e.target.value)
                                }}
                            />
                            <Typography variant="body2" color="textSecondary">
                                *Note:  Add your contact details if you want him to contact you*
                            </Typography>
                        </Box>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button sx={{ mr: 1 }} variant="contained" color="info" onClick={handleSend}>
                        Send Message
                    </Button>
                    <Button variant="contained" color="error" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        ) : null);
};

export default SendMessageModal;
